import http from './httpService';
import config from './../config.json';

export const getAllOrders = (params, {cancelToken}) => {
	return http.get(config.api_order, {cancelToken, params});
}

export const getUserOrders = (params, {cancelToken}) => {
	return http.get(`${config.api_order}/userorders`, {cancelToken, params});
}

export const changeStatusOrderById = (_id) => {
	return http.get(`${config.api_order}/${_id}`);
}

export const createStaffOrder = (order) => {
	return http.post(`${config.api_order}/staff-order`, order);
}
export const createScrapOrder = (order) => {
	return http.post(`${config.api_order}/scrap-order`, order);
}

export const deleteOrderById = (_id) => {
	return http.delete(`${config.api_order}/${_id}`);
}


